export const SET_DOCTOR_LIST = 'SET_DOCTOR_LIST';
export const SET_DOCTOR_DETAIL = 'SET_DOCTOR_DETAIL';


//设置课程资源
export const SET_RESOURCE_LIST = 'SET_RESOURCE_LIST';

//是否显示右侧资源列表

export const SET_SWIPER_FLAG = 'SET_SWIPER_FLAG';

//当前选择资源

export const  SET_CURRENT_RESOURCE = 'SET_CURRENT_RESOURCE';

//设置当前资源Id

export const SET_RESOURCEID = 'SET_RESOURCEID';

////是否隐藏右侧资源

export const SET_Right = 'SET_Right';


//是否隐藏右侧资源

export const SET_NOTE = 'SET_NOTE';

//是否显示切换按钮

export const SET_SWITCH = 'SET_SWITCH';

// 笔记列表

export const SET_NOTE_LIST = 'SET_NOTE_LIST';

//考生试卷获取，下载试卷

export const SELECT_TEST_DATA = 'SELECT_TEST_DATA';

//set试题数据

export const  SET_QUESTION_DATA = 'SET_QUESTION_DATA';

//记录考生选择答案

export const SAVE_ANSWER_SUCCESS = 'SAVE_ANSWER_SUCCESS';


// 保存考生上次选择的答案

export const SAVE_PRE_ANSWER = 'SAVE_PRE_ANSWER';

//左侧数据

export const SET_LEFT_DATA = 'SET_LEFT_DATA';

export const MAKE_ANSWER = 'MAKE_ANSWER';



// WEBPACK FOOTER //
// ./src/store/mutation-types.js